import React from 'react';

const TableHeader = (props) => {
    return (
        <div className="col-xs-12">
            <h3 className="divisor-section">{(props.data != undefined && props.data != "") && props.data}</h3>
        </div>
    );
}

export default TableHeader;